export default __webpack_public_path__ + "c0d4612c171feb6b74ef37cdfc46a4db.png";